export default "__VITE_ASSET__Dlk8txra__"